<template lang="pug">
div(class="tw-h-full tw-max-h-full tw-overflow-hidden tw-bg-white tw-rounded-md tw-mx-4  tw-shadow tw-px-0")
  v-row(no-gutters align="stretch" class=" tw-h-full tw-max-h-full tw-my-2 ")
    v-col(class="tw-h-full")
      v-row(no-gutters align="center" class="tw-flex-grow-0 tw-bg-gray-lighten-3 tw-shadow  tw-px-2 tw-py-1")
        v-col(cols="stretch")
          div
            div(v-if="!property")
              v-skeleton-loader(type="heading")
            div(v-else)
              span(class="pl-2 tw-text-2xl tw-font-semibold tw-text-indigo-lighten-1") {{ property.name }}
          div(class="pt-1 tw-text-md tw-font-semibold tw-text-gray-700")
            div(v-if="!property")
              v-skeleton-loader(type="text")
            div(v-else)
              span(class="pl-2 ") {{ property.address_street }}
              span(class="pl-1" v-if="property.address_street_number") No. {{ property.address_street_number }}
              span(class="pl-1" v-if="property.address_extended_address") {{ property.address_extended_address }},
              span(class="pl-1" v-if="property.address_city") {{ property.address_city }},
              span(class="pl-1" v-if="property.address_state") {{ property.address_state }}
              span(class="pl-1" v-if="property.address_zip_code") {{ property.address_zip_code }}
        v-col(cols="auto")
          v-btn(
            v-if="!$vuetify.breakpoint.mobile"
            depressed
            color="rgba(94,129,244,0.80)"
            @click="editListingDialogToggle"
          )
            span(class="tw-font-bold") {{ $t('Common.edit') }}

          v-menu(
            offset-y
            nudge-left="5"
            nudge-bottom="3"
            left
            dark
            class="tw-mx-0 tw-px-0 tw-mt-2"
          )
            template(v-slot:activator="{ on, attrs }")
              v-btn(
                @click=""
                v-bind="attrs"
                width="5"
                min-width="5"
                dense
                color="blue-grey"
                plain
                tile
                text
                v-ripple="false"
                v-on="on"
                class=" tw-p-0 k-btn-context"
              )
                v-icon(size="26px" class=" tw-pl-0 tw-mb-0 tw-pr-1 tw-pb-1") mdi-dots-vertical
            v-list(dense)
              v-list-item(class="tw-px-0")
                v-btn(@click="" text block class="my-0")
                  v-row(no-gutters class="tw-cursor-pointer")
                    v-col(cols="auto" class="mr-1")
                      v-icon(small color="white") mdi-share
                    v-col(cols="auto")
                      span(class=" tw-text-white tw-font-bold") {{ $t('Common.share') }}
              v-list-item(class="tw-px-0")
                v-btn(@click="deleteItem()" text block class="my-0")
                  v-row(no-gutters class="tw-cursor-pointer")
                    v-col(cols="auto" class="mr-1")
                      v-icon(small color="white") mdi-trash-can
                    v-col(cols="auto")
                      span(class=" tw-text-white tw-font-bold") {{ $t('Common.delete') }}
      v-row(no-gutters class="tw-pt-4 tw-pb-24 tw-flex-grow tw-max-h-full tw-overflow-y-scroll tw-w-full tw-px-2")
        v-col(cols="12")
          v-row(dense)
            v-col(cols="12" md="6" class="px-2")
              v-row(no-gutters)
                v-col
                  kubiqa-goods-edit-image-galery(:key="mKey")
              v-row(no-gutters)
                v-col(class="tw-mt-2")
                  div(v-if="!property")
                    v-skeleton-loader(type="paragraph" class="tw-pt-2")
                  div(v-else)
                    span(class="tw-leading-snug") {{ property.description }}
            v-col(cols="12" md="6" class="px-2")
              v-row(no-gutters align="center" class="tw-pb-2")
                v-col(cols="auto")
                  span(class="tw-font-semibold tw-text-gray-700 tw-capitalize") {{ $t('Listings.Common.details') }}
                v-col(class="px-2")
                  v-divider(class="tw-border-solid tw-border-t")
              v-row(no-gutters justify="space-around" class="tw-text-sm tw-pt-2")
                v-col(cols="3")
                  div(v-if="property.type" class=" tw-align-middle")
                    span(class="tw-block tw-text-xs tw-capitalize") {{ $t('Listings.Common.propertyType') }}
                    span(class=" tw-block tw-align-middle tw-text-base tw-pl-1") {{ property.type }}
                  div(v-if="property.construction_size" class=" tw-align-middle tw-pt-2")
                    span(class="tw-block tw-text-xs tw-capitalize") {{ $t('Listings.Common.capitalize') }}
                    span(class=" tw-block tw-align-middle tw-text-base tw-pl-1") {{ property.construction_size }} m<sup>2</sup>
                  div(v-if="property.plot_size" class=" tw-align-middle tw-pt-2")
                    span(class="tw-block tw-text-xs tw-capitalize") {{ $t('Listings.Common.plotSize') }}
                    span(class=" tw-block tw-align-middle tw-text-base tw-pl-1") {{ property.plot_size }} m<sup>2</sup>
                v-col(cols="3")
                  div(v-if="property.bedrooms" class=" tw-align-middle")
                    span(class="tw-block tw-text-xs tw-capitalize") {{ $t('Listings.Common.bedrooms') }}
                    span(class=" tw-block tw-align-middle tw-text-base tw-pl-1 ") {{ property.bedrooms }} {{ $t('Listings.Common.bedrooms') }}
                  div(v-if="property.bathrooms" class=" tw-align-middle tw-pt-2")
                    span(class="tw-block tw-text-xs tw-capitalize") {{ $t('Listings.Common.bathrooms') }}
                    span(class=" tw-block tw-align-middle tw-text-base tw-pl-1 ") {{ property.bathrooms }} {{ $t('Listings.Common.bathrooms') }}
                  div(v-if="property.parking_spaces" class=" tw-align-middle tw-pt-2")
                    span(class="tw-block tw-text-xs tw-capitalize") {{ $t('Listings.Common.parkingSpaces') }}
                    span(class="tw-block tw-align-middle tw-text-base tw-pl-1 ") {{ property.parking_spaces }} {{ $t('Listings.Common.parking') }}
                v-col(cols="3")
                  div(v-if="property.floors" class=" tw-align-middle tw-pt-2")
                    span(class="tw-block tw-text-xs tw-capitalize") {{ $t('Listings.Common.floors') }}
                    span(class="tw-block tw-align-middle tw-text-base tw-pl-1 ") {{ property.floors }} {{ $t('Listings.Common.floors') }}
                  div(v-if="property.year_built" class=" tw-align-middle tw-pt-2")
                    span(class="tw-block tw-text-xs tw-capitalize") {{ $t('Listings.Common.yearBuilt') }}
                    span(class="tw-block tw-align-middle tw-text-base tw-pl-1 ") {{ property.year_built }}
              v-row(no-gutters align="start" class="tw-pt-0")
                v-col(cols="12")
                  div(v-if="!amenities")
                    v-row(dense)
                      v-col
                        v-skeleton-loader(type="heading")
                    v-row(dense justify="space-around")
                      v-col(cols="auto")
                        v-skeleton-loader(type="table-cell@3")
                      v-col(cols="auto")
                        v-skeleton-loader(type="table-cell@3")
                      v-col(cols="auto")
                        v-skeleton-loader(type="table-cell@3")
                  div(v-else)
                    kubiqa-goods-edit-amenities-list(:key="mKey" :amenities="amenities")
              v-row(no-gutters align="center" class="tw-pt-2 tw-pb-0")
                v-col(cols="auto")
                  span(class="tw-font-semibold tw-text-gray-700 tw-capitalize") {{ $t('Listings.Common.map') }}
                v-col(class="px-2")
                  v-divider(class="tw-border-solid tw-border-t")
              v-row
                v-col
                  div(v-if="!position || !property")
                    v-skeleton-loader(type="image")
                  div(v-else)
                    kubiqa-misc-map(:key="property.id" :position="position")
          v-row(dense class="tw-pt-0")
            v-col(cols="12")
              div(v-if="!contacts")
                v-row(dense)
                  v-skeleton-loader(type="heading")
              div(v-else)
                kubiqa-goods-edit-contacts-list(:key="mKey" :contacts="contacts")

  v-dialog(v-model="editListingDialog" width="75%" max-width="75%")
    div(class="tw-bg-white add-listing-modal")
      kubiqa-goods-edit-main(:key="mKey" @close="editListingDialogToggle")
</template>
<script>
export default {
  data() {
    return {
      test: '',
      editListingDialog: false,
      mKey: 1,
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    property() {
      return this.$store.getters['properties/property'];
    },
    images() {
      return this.$store.getters['galleries/images'];
    },
    contacts() {
      return this.$store.getters['properties/contacts/list'];
    },
    amenities() {
      return this.$store.getters['properties/amenities'];
    },
    position() {
      let position = {};
      let property = this.$store.getters['properties/property'];
      if (property) {
        position.lat = property.address_latitude;
        position.lng = property.address_longitude;
      }
      return position;
    },
  },
  watch: {
    id() {
      this.getListing();
    },
  },
  mounted() {
    this.getListing();
  },
  methods: {
    editListingDialogToggle() {
      this.mKey = ++this.mKey;
      return (this.editListingDialog = !this.editListingDialog);
    },
    getListing() {
      this.$store.commit('properties/SET_CURRENT_PROPERTY', this.id);
      let property = null;
      this.$store
        .dispatch('properties/viewProperty', this.id)
        .then((response) => {
          property = this.$store.getters['properties/property'];
          if (property.gallery && !property.gallery.length) {
            let data = {};
            data.type = 'photos';
            data.parent_id = property.id;
            data.parent_type = 'App\\Models\\Property';
            this.$store.dispatch('galleries/addGallery', data);
          } else {
            this.gallery_id = this.$store.getters['properties/property'].gallery.find(
              ({ type }) => type === 'photos'
            ).id;
          }
        })
        .catch((error) => {
          this.$store.commit('SET_ERROR', error, { root: true });
        });
      this.$store
        .dispatch('properties/amenities', this.id)
        .then((response) => {
          this.mKey = ++this.mKey;
        })
        .catch((error) => {
          this.$store.commit('SET_ERROR', error, { root: true });
        });
      this.$store.dispatch('properties/contacts/getContacts', this.id);
      this.mKey = ++this.mKey;
    },
    deleteItem() {
      this.property.item_type = 'properties';
      this.$store.commit('SET_DELETE', this.property);
    },
  },
};
</script>

<style lang="css">
.add-listing-modal {
  height: 80vh !important;
  max-height: 600px;
}
</style>
